import ExploreCourts from 'screens/ExploreCourts';

export default ExploreCourts;
